export const exportHeaders = [
    {
        label: "Member ID",
        key: "loyalty_id"
    },
    {
        label: "Old Tier",
        key: "old_tier",
    },
    {
        label: "New Tier",
        key: "new_tier",
    },
    {
        label: "System Managed",
        key: "Loyalty_Account.system_managed",
    },
    {
        label: "Start Date",
        key: "start_date",
    },
    {
        label: "End Date",
        key: "end_date",
    },
    {
        label: "Initiated By",
        key: "altered_by",
    },
    {
        label: "Updated By",
        key: "User.email",
    },
    {
        label: "Reason",
        key: "reason"
    },
   
]